import {setSmoothScroll} from "./general";

document.addEventListener('DOMContentLoaded', () => {
	const heightHeader = document.querySelector('.page__header').clientHeight;
	const headerTopBlock = document.querySelector('.header__top-block');

	window.addEventListener('scroll', () => {
		const scrollYWindow = Math.round(window.scrollY);
		if (scrollYWindow > heightHeader) {
			headerTopBlock.classList.add('header__top-block--scrolled');
		} else {
			headerTopBlock.classList.remove('header__top-block--scrolled');
		}
	});

	//	Scroll-up
	const isElementVisible = (elem) => {
		const rect = elem.getBoundingClientRect(),
			vWidth = window.innerWidth || doc.documentElement.clientWidth,
			vHeight = window.innerHeight || doc.documentElement.clientHeight,
			efp = (x, y) => document.elementFromPoint(x, y);

		// Return false if it not in the viewport
		if (rect.right < 0 || rect.bottom < 0
			|| rect.left > vWidth || rect.top > vHeight)
			return false;

		// Return true if any of its four corners are visible
		return (
			elem.contains(efp(rect.left, rect.top))
			|| elem.contains(efp(rect.right, rect.top))
			|| elem.contains(efp(rect.right, rect.bottom))
			|| elem.contains(efp(rect.left, rect.bottom))
		);
	};

	const scrollUpButton = document.querySelector('.scroll-up');
	const elementTarget = document.querySelector('footer');

	if (scrollUpButton) {
		window.addEventListener('scroll', function () {
			if (isElementVisible(elementTarget)) {
				const heightElementTarget = elementTarget.offsetHeight;
				scrollUpButton.classList.add('scroll-up--show');
				scrollUpButton.style.bottom = (heightElementTarget + 10) + 'px';
			} else {
				scrollUpButton.classList.remove('scroll-up--show');
				scrollUpButton.style = '';
			}
		});
	}

	const hash = window.location.hash;
	if (hash && isNaN(hash)) { // URL содержит hash при начальной загрузке страницы
		window.location.hash = '';
		window.history.pushState("", document.title, window.location.pathname + window.location.search);
		setSmoothScroll(hash);
	}

	const initializeSmoothScroll = () => {
		const smoothScrollElements = document.querySelectorAll('[data-scroll-target]');

		if (!smoothScrollElements) return;

		smoothScrollElements.forEach((elem) => {
			elem.addEventListener('click', () => setSmoothScroll(elem.dataset.scrollTarget));
		});
	};

	initializeSmoothScroll();
});